import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "flex sm:justify-center sm:-mt-16 mb-rem2 sm:mt-0" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "flex justify-center my-rem2 gap-4" }
const _hoisted_8 = { class: "polaroid-frame !max-w-80" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "image-subtitle" }
const _hoisted_11 = { class: "polaroid-frame !max-w-80" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "image-subtitle" }
const _hoisted_14 = { class: "columns justify-center my-rem2 !gap-4" }
const _hoisted_15 = { class: "polaroid-frame !max-w-md mb-6" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "image-subtitle" }
const _hoisted_18 = { class: "polaroid-frame !max-w-md mb-6" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "image-subtitle" }
const _hoisted_21 = { class: "section mb-16" }
const _hoisted_22 = {
  id: "invisalign-cena",
  style: {"display":"block"}
}
const _hoisted_23 = { class: "text-black" }
const _hoisted_24 = { class: "section" }
const _hoisted_25 = {
  id: "invisalign-cena",
  style: {"display":"block"}
}
const _hoisted_26 = { class: "text-black" }
const _hoisted_27 = ["innerHTML"]

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Invisalign',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.invisalign.title'),
    cover: require('@/assets/covers/invisalign2.webp'),
    "cover-offset": ['10%', '0'],
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/invisalign-smile.jpg'),
          class: "big !hidden sm:!block"
        }, null, 8, ["image"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "max-w-64",
            src: require('@/assets/invisalign-provider.jpg'),
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "desktop-only" }, null, -1)),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.invisalign.intro1')
        }, null, 8, _hoisted_4),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/invisalign-scaner.webp'),
          float: "left",
          class: "sm:big"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.invisalign.intro2')), 1)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/invisalign-smile.jpg'),
          class: "!block sm:!hidden"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.invisalign.benefit1Bold')), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.invisalign.benefit2')), 1)
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.invisalign.clinicalTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.invisalign.clinicalP')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: require('@/assets/invisalign-model-before.jpg'),
              class: "w-full",
              loading: "lazy",
              alt: ""
            }, null, 8, _hoisted_9),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('articles.invisalign.beforeTherapy')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: require('@/assets/invisalign-model-after.jpg'),
              class: "w-full",
              loading: "lazy",
              alt: ""
            }, null, 8, _hoisted_12),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('articles.invisalign.afterTherapy')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: require('@/assets/invisalign-before.jpg'),
              loading: "lazy",
              alt: ""
            }, null, 8, _hoisted_16),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('articles.invisalign.beforeTherapy')), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              src: require('@/assets/invisalign-after.jpg'),
              loading: "lazy",
              alt: ""
            }, null, 8, _hoisted_19),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('articles.invisalign.afterTherapy')), 1)
          ])
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("h2", _hoisted_22, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.invisalign.goldTitlePre')) + " ", 1),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("b", _hoisted_23, _toDisplayString(_ctx.$t('articles.invisalign.goldTitleBold')), 1)
        ]),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/invisalign-golden-provider-portrait.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.invisalign.goldP1pre')) + ": ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.invisalign.goldP1Bold')), 1),
          _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.invisalign.goldP2')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.invisalign.goldP3')), 1)
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h2", _hoisted_25, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.invisalign.priceTitlePre')) + " ", 1),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("b", _hoisted_26, _toDisplayString(_ctx.$t('articles.invisalign.priceTitleBold')), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('articles.invisalign.pricePre')
          }, null, 8, _hoisted_27),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.invisalign.priceCenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'invisalign')))
          }, _toDisplayString(_ctx.$t('articles.invisalign.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.invisalign.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})